import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import useAuth from "../hooks/use-auth";

function Check(props) {

    const auth = useAuth();
    const shouldRender = props.negate ? !auth.check() : auth.check();

    return shouldRender ? props.children : null;
}

Check.defaultProps = {
    forceModel: false,
    negate: false,
};

Check.propTypes = {
    negate: PropTypes.bool,
    forceModel: PropTypes.bool,
    permission: PropTypes.string.isRequired,
};

export default observer(Check);
